import React from "react";

const RULER_PX = 22; // height/width in CSS pixels

// Horizontal/vertical ruler in mm. Ticks every 10mm with labels, sub-ticks every 5mm.
export function RulerH({ widthMm, pxPerMm, offsetMm = 0 }) {
  const widthPx = widthMm * pxPerMm;
  const offsetPx = offsetMm * pxPerMm;
  const ticks = [];
  const major = 10;
  const total = Math.floor(widthMm / major) + 1;
  for (let i = 0; i <= total; i++) {
    const mm = i * major;
    if (mm > widthMm) continue;
    ticks.push(
      <div
        key={`h${i}`}
        style={{ left: `${offsetPx + mm * pxPerMm}px`, height: "60%" }}
        className="absolute bottom-0 w-px bg-[#4B5563]"
      >
        <span
          className="absolute -top-3 left-0.5 text-[9px] font-mono text-[#9CA3AF] leading-none"
          style={{ transform: "translateX(0)" }}
        >
          {mm}
        </span>
      </div>
    );
  }
  // sub ticks every 5mm
  for (let mm = 5; mm <= widthMm; mm += 10) {
    ticks.push(
      <div
        key={`hs${mm}`}
        style={{ left: `${offsetPx + mm * pxPerMm}px`, height: "30%" }}
        className="absolute bottom-0 w-px bg-[#4B5563]/60"
      />
    );
  }
  return (
    <div
      className="relative bg-[#1C1F24] border-b border-[#31373E] select-none"
      style={{ height: `${RULER_PX}px`, width: "100%" }}
      data-testid="ruler-h"
    >
      {ticks}
    </div>
  );
}

export function RulerV({ heightMm, pxPerMm, offsetMm = 0 }) {
  const offsetPx = offsetMm * pxPerMm;
  const heightPx = heightMm * pxPerMm;
  const ticks = [];
  const major = 10;
  const total = Math.floor(heightMm / major) + 1;
  for (let i = 0; i <= total; i++) {
    const mm = i * major;
    if (mm > heightMm) continue;
    ticks.push(
      <div
        key={`v${i}`}
        style={{ top: `${offsetPx + mm * pxPerMm}px`, width: "60%" }}
        className="absolute right-0 h-px bg-[#4B5563]"
      >
        <span className="absolute -left-0.5 -top-1 text-[9px] font-mono text-[#9CA3AF] leading-none" style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}>
          {mm}
        </span>
      </div>
    );
  }
  for (let mm = 5; mm <= heightMm; mm += 10) {
    ticks.push(
      <div
        key={`vs${mm}`}
        style={{ top: `${offsetPx + mm * pxPerMm}px`, width: "30%" }}
        className="absolute right-0 h-px bg-[#4B5563]/60"
      />
    );
  }
  return (
    <div
      className="relative bg-[#1C1F24] border-r border-[#31373E] select-none shrink-0"
      style={{ width: `${RULER_PX}px`, height: `${heightPx}px` }}
      data-testid="ruler-v"
    >
      {ticks}
    </div>
  );
}

export const RULER_SIZE = RULER_PX;
